import React, { Component } from 'react';
/*import PropTypes from 'prop-types'*/
import Aux from '../../../_hoc/_Aux';
import styles from './Input.scss';

class Input extends Component {

  // Backspace-Funktion
  checkValues = (event, target) => {
    /*if(this.props.type=="number"){
      if(event.target.value){
        if(this.props.minValue){
          if(event.target.value<this.props.minValue){
            event.target.value = this.props.minValue;
            if(this.props.onCheckValuesError) {
              this.props.onCheckValuesError(this.props.minValue ? this.props.minValue : null, this.props.maxValue ? this.props.maxValue : null);
            }
          }
        }
        if(this.props.maxValue){
          if(event.target.value>this.props.maxValue){
            event.target.value = event.target.value.substr(0,event.target.value.length-1);
            if(this.props.onCheckValuesError) {
              this.props.onCheckValuesError(this.props.minValue ? this.props.minValue : null, this.props.maxValue ? this.props.maxValue : null);
            }
          }
        }
      }
    }*/
    if(this.props.validationPattern) {
      const regex = new RegExp(this.props.validationPattern, 'g');
      if(!regex.test(event.target.value)) {
        event.target.value = event.target.value.substr(0,event.target.value.length-1);
      }
    }
    this.props.changed(event, this.props.identifier)
  }

  render() {

    return (
    	<Aux>
    		<input  className={styles.defaultInput}
                onChange={(event) => this.checkValues(event, this.props.identifier)}
                onKeyUp={this.props.keyupped ? (event) => this.props.keyupped(event, this.props.identifier) : null}
                onBlur={this.props.blurred ? (event) => this.props.blurred(event, this.props.identifier) : null}
                onFocus={this.props.focused ? (event) => this.props.focused(event, this.props.identifier) : null}
                onPaste={this.props.pasted ? (event) => this.props.pasted(event, this.props.identifier) : null}
                value={this.props.value}
                type={this.props.type}
                selected={this.props.selected ? true : false}
                placeholder={this.props.placeholder}
                data-hasvalue={this.props.value !== null && this.props.value !== "" ? true : false}
                disabled={this.props.disabled ? true : false}
                step={this.props.type === "number" && this.props.step ? this.props.step : null}
                />
      </Aux>
    )
  }
}
/*
Input.propTypes = {
  value: PropTypes.node.isRequired,
  changed: PropTypes.any.isRequired,
  elementConfig: PropTypes.any.isRequired,
  elementType: PropTypes.any.isRequired,
}*/

export default Input



// WEBPACK FOOTER //
// ./src/components/atoms/Input/index.js